import { CircleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type PackagingItemSkuCellProps = {
  sku: string
  skuInBomList: boolean
}

export function PackagingItemSkuCell({
  sku,
  skuInBomList,
}: PackagingItemSkuCellProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <span className='flex min-w-0 items-center gap-1.5'>
      <span className='truncate'>{sku}</span>
      {skuInBomList && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className='inline-flex shrink-0 text-blue-600 dark:text-blue-400'
              aria-label={t('items.skuInBomListTooltip')}
            >
              <CircleAlert className='size-3.5' aria-hidden />
            </span>
          </TooltipTrigger>
          <TooltipContent side='top' className='max-w-xs'>
            {t('items.skuInBomListTooltip')}
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  )
}
